// Auto-generated by scripts/gen-build-info.mjs. Do not edit.
import type { BuildInfo } from "./build-info.js";
export const BUILD_INFO: BuildInfo = {
  "sha": "dev",
  "time": 1793839848340,
  "notes": []
};
